import { render, staticRenderFns } from "./d-book-review-book.vue?vue&type=template&id=61e8c1c5&"
import script from "./d-book-review-book.vue?vue&type=script&lang=js&"
export * from "./d-book-review-book.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports